export default __webpack_public_path__ + "static/media/hissnmuslim.136df1fe.jpg";